import React from "react"
import { useSelector } from "react-redux";
import PropTypes from 'prop-types'
import { ThemeNav, ThemeNavActive } from "../Theme"

const Tab = ({ tabs, page, setPage }) => {
    return (
        <div className="cursor-pointer flex flex-row items-center justify-center">
            {tabs.map((tabName, idx) => (
                page === idx ?
                    <ThemeNavActive
                        key={idx}
                        className={`w-32 h-12 
                    font-semibold flex flex 
                    items-center justify-center
                    ${(idx === 0) ? "rounded-tl-full rounded-bl-full" : (idx === tabs.length - 1) ? "rounded-tr-full rounded-br-full " : ""}
                    ${(tabs.length === 1) && "rounded-tr-full rounded-br-full "}
                    ${`hover:opacity-70`}`}
                        onClick={() => setPage(idx)}
                    >
                        {tabName}
                    </ThemeNavActive> :
                    <ThemeNav
                        key={idx}
                        className={`w-32 h-12
                        font-semibold flex flex
                        items-center justify-center bg-gray-200
                        ${(idx === 0) ? "rounded-tl-full rounded-bl-full " : (idx === tabs.length - 1) ? "rounded-tr-full rounded-br-full " : ""}
                        ${(tabs.length === 1) && "rounded-tr-full rounded-br-full "}
                        ${`bg-gray-400 text-gray-600 hover:opacity-70`}
                `}
                        onClick={() => setPage(idx)}
                    >
                        {tabName}
                    </ThemeNav>
            ))}
        </div>
    )
}

Tab.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.string,
    ),
    page: PropTypes.number,
    setPage: PropTypes.func,
}

export default Tab
